<template>

  <div class="block w-full space-y-2" :class="{ 'p-5': padding }">

    <div class="w-full flex flex-col md:flex-row">

      <Field name="tipo" v-slot="{ handleChange, handleBlur, value, errors }" v-model="tipo">
        <Dropdown @blur="handleBlur" @update:model-value="handleChange" :model-value="value" placeholder="Buscar por..."
          class="input-base" :options="tipos" optionLabel="descripcion"
          :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }" />
      </Field>
      <InputGroup class="flex-grow ml-0 md:ml-2 mt-2 md:mt-0">
        <InputText @keyup="filtrar" v-model="filtroTexto" placeholder="Buscar..." class="input-base no-rounded-right" />
        <Button @click="limpiarFiltro" icon="pi pi-times"
          class="border borde-red-700 bg-red-700 text-white no-rounded-left hover:bg-transparent hover:text-red-700 hover:border-red-700"></Button>
      </InputGroup>
    </div>

    <div class="w-full flex flex-col">
      <div v-if="tags">
        <div class="flex flex-wrap -mx-1">
          <div v-for="tag in tags" :key="tag.id" class="w-full md:w-1/2 lg:w-1/4 px-1 pb-2">
            <Field :name="`tag-${tag.id}`">
              <MultiSelect :model-value="tag.opcionesTagSeleccionados"
                @update:model-value="val => { tag.opcionesTagSeleccionados = val; filtrar(); }" :options="tag.opciones"
                optionLabel="descripcion" optionValue="id" filter :placeholder="tag.descripcion" class="input-base" />
            </Field>
          </div>
        </div>
      </div>
    </div>

    <div class="w-full flex flex-row gap-x-2">
      <ToggleSwitch :model="vistaCompacta" @click="changeViewMode()" /> Vista compacta
    </div>

    <div class="w-full flex flex-col" v-if="tipo.id == 1">
      <DataView :value="empresasFiltradas" paginator :rows="20" :alwaysShowPaginator="false" dataKey="item.id">
        <template #empty>
          <div
            class="w-full flex flex-row items-center justify-center px-5 py-5 text-2xl font-semibold text-center text-gray-500">
            No hay expositores
          </div>
        </template>
        <template #list="slotProps">

          <!-- VISTA COMPACTA -->
          <div v-if="vistaCompacta">
            <div class="flex flex-wrap -mx-1 mt-3">
              <div v-for="(item, index) in slotProps.items" :key="index" class="w-full md:w-1/2 lg:w-1/4 px-1 pb-2">

                <div
                  class="relative p-2 w-full h-full bg-gray-50 shadow-xl border border-gray-200 rounded-lg cursor-pointer hover:bg-gray-200 group">
                  <div class="grid grid-cols-4 gap-2">
                    <div class="w-full aspect-square overflow-hidden rounded-lg border border-gray-300 col-span-1">
                      <img :src="item.previewLogo" :class="fitClass" class="w-full h-full object-center"
                        @load="onImageLoad" />
                    </div>
                    <div class="flex flex-col w-full flex-grow flex-1 col-span-3 justify-center">
                      <div class="font-semibold line-clamp-1 text-sm">
                        {{ item.nombreFantasia }}
                      </div>
                      <div class="text-gray-600 text-xs">
                        <font-awesome-icon :icon="['fas', 'phone']" /> {{ item.telefono }}
                      </div>
                      <div class="text-gray-600 text-xs">
                        <font-awesome-icon :icon="['fas', 'location-dot']" /> {{ item.domicilio }}
                      </div>
                      <div class="text-gray-600 text-xs">
                        <font-awesome-icon :icon="['far', 'envelope']" /> {{ item.mailComercial }}
                      </div>
                    </div>
                  </div>

                  <!-- HOVER COMPACTO -->
                  <div @click="mostrarDetalleEmpresa(item)"
                    class="absolute inset-0 bg-black bg-opacity-60 flex flex-col items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-lg cursor-pointer">
                    <font-awesome-icon :icon="['fas', 'search']" class="text-white text-2xl mb-1" />
                    <span class="text-white text-sm font-semibold">MAS INFORMACIÓN</span>
                  </div>
                </div>


              </div>
            </div>
          </div>
          <!-- FIN VISTA COMPACTA -->

          <!-- VISTA FULL -->
          <div v-if="!vistaCompacta">
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-3 text-sm">
              <div v-for="(item, index) in slotProps.items" :key="index">
                <div
                  class="p-3 w-full h-full bg-gray-50 shadow-xl border border-gray-200 rounded-md text-center flex flex-col">

                  <div class="flex flex-col w-full flex-grow flex-1">
                    <div class="w-full aspect-square overflow-hidden rounded-lg border border-gray-300">
                      <img :src="item.previewLogo" :class="fitClass" class="w-full h-full object-center"
                        @load="onImageLoad" />
                    </div>

                    <div class="py-2">
                      <div class="font-semibold line-clamp-1">
                        {{ item.nombreFantasia }}
                      </div>
                      <div class="text-gray-600 text-sm line-clamp-1">
                        <font-awesome-icon :icon="['fas', 'phone']" /> {{ item.telefono }}
                      </div>
                      <div class="text-gray-600 text-sm line-clamp-1">
                        <font-awesome-icon :icon="['fas', 'location-dot']" /> {{ item.domicilio }}
                      </div>
                      <div class="text-gray-600 text-sm line-clamp-1">
                        Stand : {{ item.stand }}
                      </div>
                      <div class="text-gray-600 text-sm line-clamp-1">
                        <font-awesome-icon :icon="['far', 'envelope']" /> {{ item.mailComercial }}
                      </div>
                    </div>

                    <div class="w-full flex flex-col mt-auto">
                      <a @click="mostrarDetalleEmpresa(item)"
                        class="py-1 mt-2 block rounded border border-black bg-transparent text-black hover:bg-black hover:text-white cursor-pointer">
                        <font-awesome-icon :icon="['fas', 'plus']" /> MAS INFORMACIÓN
                      </a>
                    </div>

                  </div>

                </div>
              </div>
            </div>
          </div>
          <!-- FIN VISTA FULL -->


        </template>
      </DataView>
    </div>

    <!--
    ***********************************************************************************
    *****************************************PRODUCTOS*********************************
    ***********************************************************************************
    -->

    <div class="w-full flex flex-col" v-if="tipo.id == 2">
      <DataView :value="productosFiltrados" paginator :rows="16" :alwaysShowPaginator="false" dataKey="item.id">
        <template #empty>
          <div
            class="w-full flex flex-row items-center justify-center px-5 py-5 text-2xl font-semibold text-center text-gray-500">
            No hay productos
          </div>
        </template>
        <template #list="slotProps">

          <!-- VISTA COMPACTA -->
          <div v-if="vistaCompacta">
            <div class="flex flex-wrap -mx-1 mt-3">
              <div v-for="(item, index) in slotProps.items" :key="index" class="w-full md:w-1/2 lg:w-1/4 px-1 pb-2">

                <div
                  class="relative p-2 w-full h-full bg-gray-50 shadow-xl border border-gray-200 rounded-lg cursor-pointer hover:bg-gray-200 group">
                  <div class="grid grid-cols-4 gap-2">
                    <div class="w-full aspect-square overflow-hidden rounded-lg border border-gray-300 col-span-1">
                      <img :src="item.previewFotoFile" class="w-full h-full object-cover object-center" />
                    </div>
                    <div class="flex flex-col w-full flex-grow flex-1 col-span-3 justify-center">
                      <div class="font-semibold line-clamp-1 text-sm">
                        {{ item.descripcion }}
                      </div>
                      <div class="text-gray-600 text-xs line-clamp-2">
                        {{ item.detalles }}
                      </div>
                    </div>
                  </div>

                  <!-- HOVER COMPACTO -->
                  <div @click="mostrarDetalleEmpresa(item.empresa)"
                    class="absolute inset-0 bg-black bg-opacity-60 flex flex-col items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-lg cursor-pointer">
                    <font-awesome-icon :icon="['fas', 'search']" class="text-white text-2xl mb-1" />
                    <span class="text-white text-sm font-semibold">MAS INFORMACIÓN</span>
                  </div>
                </div>


              </div>
            </div>
          </div>
          <!-- FIN VISTA COMPACTA -->

          <!-- VISTA FULL -->
          <div v-if="!vistaCompacta">
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-3 text-sm">
              <div v-for="(item, index) in slotProps.items" :key="index">
                <div
                  class="p-3 w-full h-full bg-gray-50 shadow-xl border border-gray-200 rounded-md text-center flex flex-col">

                  <div class="flex flex-col w-full flex-grow flex-1">
                    <div class="w-full aspect-square overflow-hidden rounded-lg border border-gray-300">
                      <img :src="item.previewFotoFile" class="w-full h-full object-cover object-center" />
                    </div>

                    <div class="py-2">
                      <div class="font-semibold line-clamp-1">
                        {{ item.descripcion }}
                      </div>
                      <div class="text-gray-600 text-sm line-clamp-4">
                        {{ item.detalles }}
                      </div>
                    </div>

                    <div class="w-full flex flex-col mt-auto">
                      <a @click="mostrarDetalleEmpresa(item.empresa)"
                        class="py-1 mt-2 block rounded border border-black bg-transparent text-black hover:bg-black hover:text-white cursor-pointer">
                        <font-awesome-icon :icon="['fas', 'plus']" /> MAS INFORMACIÓN
                      </a>
                    </div>

                  </div>

                </div>
              </div>
            </div>
          </div>
          <!-- FIN VISTA FULL -->


        </template>
      </DataView>
    </div>
  </div>

  <BlockUI :blocked="isSubmitting" fullScreen />

  <Dialog v-model:visible="masInformacionVisible" modal :header="empresaSeleccionada?.nombreFantasia"
    class="w-[90%] lg:w-[60%]">
    <CatalogoDetalleView v-if="empresaSeleccionada" :empresa="empresaSeleccionada" :closeFunction="closeDialog" />
  </Dialog>

</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Field } from 'vee-validate';
import Swal from 'sweetalert2'

import BlockUI from 'primevue/blockui';
import DataView from 'primevue/dataview';
import InputText from 'primevue/inputtext';
import InputGroup from 'primevue/inputgroup';
import Button from 'primevue/button';
import MultiSelect from 'primevue/multiselect';
import ToggleSwitch from 'primevue/toggleswitch';
import Dialog from 'primevue/dialog';
import Dropdown from 'primevue/dropdown';

import empresaService from 'qreventos-suite/empresas';
import { Evento, Empresa, Tag, IdLabelEntity, EmpresaProducto } from 'qreventos-suite/src/services/suite.interfaces';
import { TAG_TIPO_PRODUCTO, TAG_TIPO_EMPRESA } from 'qreventos-suite/constantes';
import eventoServices from 'qreventos-suite/eventos';

import CatalogoDetalleView from "@/components/views/CatalogoDetalleView.vue";

export default defineComponent({
  components: {
    DataView, InputText, InputGroup, MultiSelect, ToggleSwitch,
    BlockUI, Button, Field, Dialog, Dropdown,
    CatalogoDetalleView
  },
  props: {
    padding: {
      type: Boolean,
      default: true
    }
  },
  created() {
    document.title = "Catálogo";
  },
  data() {
    return {
      fitClass: 'object-cover',
      isSubmitting: false,
      evento: undefined as unknown as Evento,
      productos: [] as EmpresaProducto[],
      empresas: [] as Empresa[],
      empresasFiltradas: [] as Empresa[],
      productosFiltrados: [] as EmpresaProducto[],
      tags: [] as Tag[],
      filtroTexto: '',
      tipo: { id: 1, descripcion: 'Empresa' } as IdLabelEntity,
      tipos: [
        { id: 1, descripcion: 'Empresa' },
        { id: 2, descripcion: 'Producto' },
      ],
      vistaCompacta: false,
      masInformacionVisible: false,
      empresaSeleccionada: undefined as unknown as Empresa
    };
  },
  watch: {
    masInformacionVisible(newVal) {
      if (newVal) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    },
    tipo: {
      handler() {
        this.reload();
      },
      deep: true
    }
  },
  methods: {
    onImageLoad(e: any) {
      const img = e.target
      if (img.naturalWidth > img.naturalHeight) {
        this.fitClass = 'object-contain h-full'
      } else {
        this.fitClass = 'object-contain w-full'
      }
    },
    closeDialog() {
      this.masInformacionVisible = false;
    },
    async limpiarFiltro() {
      this.filtroTexto = '';

      this.tags.forEach(tag => {
        tag.opcionesTagSeleccionados = [];
      });

      this.empresasFiltradas = this.empresas;
      this.productosFiltrados = this.productos;
    },
    async changeViewMode() {
      console.log(this.vistaCompacta);
      this.vistaCompacta = !this.vistaCompacta;
    },
    async mostrarDetalleEmpresa(empresa: Empresa) {
      this.isSubmitting = true;

      try {

        this.empresaSeleccionada = await empresaService.findEmpresaBy(this.evento.id, empresa.id);
        this.empresaSeleccionada.previewLogo = (empresa.previewLogo == null || empresa.previewLogo == '') ? require('@/assets/nologo.png') : empresa.previewLogo;
        this.masInformacionVisible = true;


      } catch (error) {
        this.isSubmitting = false;
        Swal.fire({ title: "Error", text: 'Empresa no encontrada ' + error, icon: "error" }).then(() => {
          window.location.reload();
        });
      } finally {
        this.isSubmitting = false;
      }
    },
    async filtrar() {
      if (this.filtroTexto === '' && this.tags.every(tag => !tag.opcionesTagSeleccionados?.length)) {
        this.limpiarFiltro();
        return;
      }


      if (this.tipo.id == TAG_TIPO_EMPRESA) {
        this.empresasFiltradas = this.empresas.filter(empresa => {
          const coincideTexto =
            empresa.nombreFantasia.toLowerCase().includes(this.filtroTexto.toLowerCase()) ||
            empresa.breveDescripcion.toLowerCase().includes(this.filtroTexto.toLowerCase());

          const coincideTags = this.tags.every(tag => {
            if (!tag.opcionesTagSeleccionados?.length) return true; // Si el tag no tiene selección no filtrar
            return empresa.empresaTags.some(empresaTag =>
              empresaTag.tag.id === tag.id &&
              tag.opcionesTagSeleccionados.includes(empresaTag.tagOpcion.id)
            );
          }
          );

          return coincideTexto && coincideTags;
        });
      } else {
        this.productosFiltrados = this.productos.filter(producto => {
          const coincideTexto =
            producto.descripcion.toLowerCase().includes(this.filtroTexto.toLowerCase()) ||
            producto.detalles.toLowerCase().includes(this.filtroTexto.toLowerCase());

          const coincideTags = this.tags.every(tag => {
            if (!tag.opcionesTagSeleccionados?.length) return true; // Si el tag no tiene selección no filtrar
            return producto.productoTags.some(productoTag =>
              productoTag.tag.id === tag.id &&
              tag.opcionesTagSeleccionados.includes(productoTag.tagOpcion.id)
            );
          }
          );

          return coincideTexto && coincideTags;
        });
      }


    },
    async reload() {
      try {
        this.isSubmitting = true;

        this.empresas = await empresaService.findEmpresasBy(this.evento.id, true);
        this.empresas = this.empresas.filter(empresa => empresa.nombreFantasia !== null && empresa.nombreFantasia !== '');
        this.empresas.forEach(empresa => {
          empresa.previewLogo = (empresa.previewLogo == null || empresa.previewLogo == '') ? require('@/assets/nologo.png') : empresa.previewLogo;
        });
        this.empresasFiltradas = this.empresas;

        this.productos = await empresaService.findEmpresasProductosBy(this.evento.id);
        this.productosFiltrados = this.productos;


        if (this.tipo.id == TAG_TIPO_EMPRESA) {
          this.tags = await empresaService.findTagsBy(this.evento.id, TAG_TIPO_EMPRESA);
        } else {
          this.tags = await empresaService.findTagsBy(this.evento.id, TAG_TIPO_PRODUCTO);
        }


      } catch (error) {
        this.isSubmitting = false;
        Swal.fire({ title: "Error", text: error + '', icon: "error" }).then(() => {
          window.location.reload();
        });
      } finally {
        this.isSubmitting = false;
      }
    },

  },
  async mounted() {
    try {

      const idEvento: number = Number(this.$route.params.id);
      if (idEvento) {
        this.evento = await eventoServices.validarEvento(idEvento);
        await this.reload();
      }
    }
    catch (error) {
      Swal.fire({ title: "Error", text: error + '', icon: "error" }).then(() => {
        window.location.reload();
      });
    }
  }
});
</script>
